import { FeatureFlagTypes } from './featureFlagsTypes.enum';

export const RouteToReactMigrationFlag: Record<string, FeatureFlagTypes> = {
  '': FeatureFlagTypes.ReactMigrationOverview,
  management: FeatureFlagTypes.ReactMigrationSettings,
  connect: FeatureFlagTypes.ReactMigrationAdapters,
  violations: FeatureFlagTypes.ReactMigrationViolations,
  inventory: FeatureFlagTypes.ReactMigrationInventory,
  'ai-findings': FeatureFlagTypes.ReactMigrationFindings,
  'ai-activity': FeatureFlagTypes.ReactMigrationActivity,
  'ai-in-line-control': FeatureFlagTypes.ReactMigrationInLineControl,
  'data-lens': FeatureFlagTypes.ReactMigrationDataLens,
  policies: FeatureFlagTypes.ReactMigrationPolicies,
  playbooks: FeatureFlagTypes.ReactMigrationPlaybooks,
  'attack-simulations': FeatureFlagTypes.ReactMigrationRedTeaming,
  hygiene: FeatureFlagTypes.ReactMigrationHygiene,
  adoption: FeatureFlagTypes.ReactMigrationAdoption,
  issues: FeatureFlagTypes.ReactMigrationIssues,
  boundaries: FeatureFlagTypes.ReactRsa2026DemoRuntimeBoundaries,
};
